// Auth API
import request from '@/utils/request'
import type { LoginByCodeForm, LoginRes, UserInfo, ChangeEmailForm } from '@/types'

export function sendLoginCode(email: string): Promise<void> {
  return request.post('/v1/auth/send-login-code', { email })
}

export function login(data: LoginByCodeForm): Promise<LoginRes> {
  return request.post('/v1/auth/login-by-code', data)
}

export function logout(): Promise<void> {
  return request.post('/v1/auth/logout')
}

export function getUserInfo(): Promise<UserInfo> {
  return request.get('/v1/admin/users/info')
}

export function sendChangeEmailCode(): Promise<void> {
  return request.post('/v1/admin/users/send-change-email-code')
}

export function sendNewEmailCode(newEmail: string): Promise<void> {
  return request.post('/v1/admin/users/send-new-email-code', null, { params: { newEmail } })
}

export function changeEmail(data: ChangeEmailForm): Promise<void> {
  return request.post('/v1/admin/users/change-email', data)
}
